const general = {
  sites: 'Sites',
  site: 'Site',
  add_site: 'New Site',
  edit_site_access: 'Edit Site Access',
  search_site: 'Search Site',
  delete_site_message: 'Are you sure you want to delete {{site}}?',
  notifications: 'Notifications',
  notification: 'Notification',
  events: 'Events',
  site_info: 'Site Information',
  add_notification: 'New Notification',
  send_to: 'Send to',
  delete_contact_message:
    'Are you sure you want to delete {{contact}} notification contact?',
  invalid_email: 'Invalid email address format',
  active_web_access: 'Active web access',
  no_web_access: 'No web access',
  select_unselect_all: 'Select/Unselect All',
  notification_at_least_one: 'Select at least one notification',
  table: {
    name: 'NAME',
    country: 'COUNTRY',
    city: 'CITY',
    state: 'STATE',
    timezone: 'TIMEZONE',
  },
};

export default general;
